// extracted by mini-css-extract-plugin
export default {"header":"styles_header__z7yQH","link":"styles_link__J+j8i","subLink":"styles_subLink__c-4pS","dropdownFooter":"styles_dropdownFooter__rniME"};